

















































































/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { EventBus } from "../event-bus";
import ConfirmationModal from "./ConfirmationModal.vue";
import axios, { AxiosResponse } from "axios";
import { Token } from "../utils/Token";
import { File } from "../models/File";
import {
    isFolderAccessSupported,
    getSavedFolder,
    chooseFolder,
    getFolderForUse,
    writeFileToFolder,
    downloadBlob,
} from "../utils/folderAccess";


/* import axios from "axios"; */

@Component({
  components: {
    ConfirmationModal,
  },
})

export default class EnDeCrypt extends Vue {

    private status = true;
    private items:Array<any> = [];

    private target = {
        id:null,
        label:"",
        status:100
    };

    private targetRules: any = [];
    private files: File[] = [];

    private tableItemRules: any = [];

    private isDownloadEnabled = true;
    private isOutlookEnabled = true;
    private isEncryptEnabled = true;
    private isDecryptEnabled = true;
    private isTargetSelectDisabled = false;
    // @Cleanup: Not used anymore. -TD
    private isSendEnabled = true;

    private changesMade = false;
    private flag = true;

    private folderAccess = isFolderAccessSupported();
    private waredName = "";

    @Prop() selected!: any;

    created() {
        if (this.selected !== undefined) {
            this.files=this.selected;
            console.log("chosen file: ", this.files);
        } else {
            console.log("no file selected");
            this.files = [];
        }

        EventBus.$on("selectedChanded", (value: File[]) => {
            if (value !== undefined) {
                this.files = value;
                console.log("SelectedChanged ED, ", this.files, this.files[0].name);
            } else {
                console.log("diselected");
                this.files = [];
            }
        });

        this.checkEnabled();
        this.targetSelectionValidation();
        this.loadWaredName();
    }

    @Watch("files")
    private targetSelectionValidation() {
        this.isTargetSelectDisabled = false;

        if (this.files !== undefined && this.files.length > 0) {
            this.isTargetSelectDisabled = this.files.some(e => e.name.includes("ramz"));
        }
    }


    @Watch("files")
    @Watch("target")
    private checkEnabled() {
        this.isSendEnabled = true;
        this.isDownloadEnabled = true;
        this.isOutlookEnabled = true;
        this.isEncryptEnabled = true;
        this.isDecryptEnabled = true;

        if (this.files !== undefined && this.files.length > 0) {
            this.isDownloadEnabled = false;
            // one encrypted file of ours (not one received from a mission)
            this.isOutlookEnabled = !(
                this.files.length == 1 &&
                this.files[0].name.endsWith(".ramz") &&
                this.getId(this.files[0]) == "-1"
            );
            this.isDecryptEnabled = this.files.some(e => !e.name.includes("ramz"));

            if (this.target.id != null) {
                this.isSendEnabled = false;
                this.isEncryptEnabled = this.files.some(e => e.type !== 0);
                this.isEncryptEnabled = this.files.some(e => e.name.includes("ramz"));
            }
        }

        console.log(
            "encr decr send down",
            this.isEncryptEnabled,
            this.isDecryptEnabled,
            this.isSendEnabled,
            this.isDownloadEnabled
        );
    }

    private async loadWaredName() {
        const wared = await getSavedFolder("wared");
        this.waredName = wared ? wared.name : "";
    }

    private async ChooseWared() {
        const wared = await chooseFolder("wared", "readwrite");
        if (wared) {
            this.waredName = wared.name;
        }
    }

    private async fetchTargets() {
        const token = await Token.getTokenWithExpiry("token");
        //EventBus.$emit("BeginLoader",null );

        axios({
            method: "get",
            withCredentials: true,
            url: `${process.env.VUE_APP_BASE_URL}/targets`,
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-type": "application/json",
            },
        })
        .then((response) => {
            //EventBus.$emit("FinishLoader",null );
            if (response.data.code == 401) {
                EventBus.$emit("LogOutEventBus", false);
            } else {
                if (response.data.code == 200) {
                    this.items = response.data.targets
                        .filter((e: { id:number, label:string, status:number; }) => e.status == 100)
                        .sort((a: { label:string }, b: { label:string }) =>
                            (a.label || "").localeCompare(b.label || "", undefined, { sensitivity: "base" }));
                    console.log("target:",this.target);
                }
            }
        })
        .catch((err) => {
            //EventBus.$emit("FinishLoader",null );
            console.log("error:", err);
        });
    }

    // @Deprecated, @Cleanup: Not used anymore. -TD
    //post /files/sendEncrypted
    private async SendFunction() {
        const token = await Token.getTokenWithExpiry("token");

        const data = {
            id: this.target.id,
            files: this.files,
        };
        //EventBus.$emit("BeginLoader",null );

        axios({
            method: "post",
            withCredentials: true,
            url: `${process.env.VUE_APP_BASE_URL}/files/sendEncrypted`,
            data: data,
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-type": "application/json",
            },
        })
        .then((response) => {
            //EventBus.$emit("FinishLoader",null );

            if (response.data.code == 401) {
                EventBus.$emit("LogOutEventBus", false);
            } else {
                this.flag = false;
                if (response.data.code == 200) {
                    const newFile = response.data.file;
                    //remove old file from table
                    EventBus.$emit("fileRemoval", this.files);
                    EventBus.$emit("changeMade");
                    console.log("sent");
                    this.flag = true;
                }

                const snackbarData = {
                    text:
                        this.flag === true
                        ? "The file has been sent."
                        : "Error: The file has not been sent.",
                    color:
                        this.flag === true
                        ? "#4caf50"
                        : "#2196f3",
                };

                EventBus.$emit("showSnackbar", snackbarData);
            }
        })
        .catch((err) => {
            //EventBus.$emit("FinishLoader",null );

            console.log("error: ", err);
        });
    }

    // post /files/encryptFile
    private async EncryptFunction(){
        const token = await Token.getTokenWithExpiry("token");
        const data = {
            files: this.files,
            target: this.target,
        };

        //EventBus.$emit("BeginLoader",null );
        axios({
            method: "post",
            withCredentials: true,
            url: `${process.env.VUE_APP_BASE_URL}/files/encryptFile`,
            data: data,
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-type": "application/json",
            },
        })
        .then((response) => {
            //EventBus.$emit("FinishLoader",null );   

            if (response.data.code == 401) {
                EventBus.$emit("LogOutEventBus", false);
            } else {
                this.flag = false;
                let name = "";

                if (response.data.code == 200) {
                    const newFile = response.data.file;
                    EventBus.$emit("newFileAddition", [newFile]);
                    //EventBus.$emit("changeMade");
                    this.flag = true;
                    name = newFile.name;
                }

                const snackbarData = {
                    text:
                        this.flag === true
                        ? "File Encrypted. " + name
                        : "Error: File not encrypted.",
                    color:
                        this.flag === true
                        ? "#4caf50"
                        : "#2196f3",
                };

                EventBus.$emit("showSnackbar", snackbarData);
                location.reload();
            }
        })
        .catch((err) => {
            //EventBus.$emit("FinishLoader",null );

            console.log("error:", err);
        });
    }

    //post /files/decryptFile
    private async DecryptFunction() {
        // the file clicked on; the selection may change while a picker is open
        const file = this.files[0];

        // Get the Wared folder first: pickers and permission prompts only work
        // while handling the click, not once the decryption has returned.
        const wared = await getFolderForUse("wared", "readwrite");
        this.waredName = wared ? wared.name : this.waredName;

        const token = await Token.getTokenWithExpiry("token");

        file.path = file.path.replaceAll(/([^:]\/)\/+/g, "$1");

        const data = {
            file: file,
            target: this.target,
        };

        //EventBus.$emit("BeginLoader",null );
        axios({
            method: "post",
            withCredentials: true,
            url: `${process.env.VUE_APP_BASE_URL}/files/decryptFile`,
            data: data,
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-type": "application/json",
            },
        })
        .then(async (response) => {
            //EventBus.$emit("FinishLoader",null );

            if (response.data.code == 401) {
                EventBus.$emit("LogOutEventBus", false);
            } else {
                this.flag = false;
                let decrypted: File[] = [];

                if (response.data.code == 200) {
                    EventBus.$emit("changeMade");
                    this.flag = true;
                    decrypted = response.data.files || [];
                }

                let text =
                    this.flag === true
                    ? "File Decrypted. "
                    : "Error: File not decrypted.";

                if (this.flag === true && decrypted.length > 0) {
                    text += await this.saveDecrypted(decrypted, wared, token);
                }

                const snackbarData = {
                    text: text,
                    color:
                        this.flag === true
                        ? "#4caf50"
                        : "#2196f3",
                    };

                EventBus.$emit("showSnackbar", snackbarData);

                // on success "changeMade" already refreshes the list; a reload
                // would hide the confirmation
                if (this.flag !== true) {
                    location.reload();
                }
            }
        })
        .catch((err) => {
            //EventBus.$emit("FinishLoader",null );

            console.log("error:", err);
            EventBus.$emit("showSnackbar", {
                text: "Error: File not decrypted.",
                color: "#2196f3",
            });
        });
    }

    // Writes the decrypted files into the Wared folder, or downloads them as
    // before when there is no folder (other browsers, cancelled or denied).
    private async saveDecrypted(files: File[], wared: any, token: string): Promise<string> {
        const saved: string[] = [];
        const downloaded: string[] = [];
        const failed: string[] = [];

        for (const file of files) {
            let blob: Blob;

            try {
                const response = await axios.get(
                    `${process.env.VUE_APP_BASE_URL}/files/download/-1/${encodeURIComponent(file.name)}`, {
                    withCredentials: true,
                    responseType: 'blob',
                    headers: {
                        Authorization: `Bearer ${token}`,
                    }
                });
                blob = response.data as Blob;
            } catch (err) {
                console.log("error:", err);
                failed.push(file.name);
                continue;
            }

            const written = wared ? await writeFileToFolder(wared, file.name, blob) : null;

            if (written !== null) {
                saved.push(written);
            } else {
                downloadBlob(blob, file.name);
                downloaded.push(file.name);
            }
        }

        const parts: string[] = [];

        if (saved.length > 0) {
            parts.push(`Saved to ${wared.name}: ${saved.join(", ")}.`);
        }
        if (downloaded.length > 0) {
            parts.push(`Downloaded: ${downloaded.join(", ")}.`);
        }
        if (failed.length > 0) {
            parts.push(`Not retrieved: ${failed.join(", ")}.`);
        }

        return parts.join(" ");
    }

    private getId(file: File) : string {
        //possible paths:
        ///root/src/files/{name}
        ///home/sct-client-x/files/received/{name}
        //if before files is root source send -1 else split(-) to get id of user

        let id = "-1";
        const temp = file.path.split("/files");
        if (temp[0] != "/root/src") {
            const temp2 = temp[0].split("-");
            id = temp2[temp2.length - 1];
            console.log(id);
        }

        return id;
    }

    //get /files/download/:id/:name
    private async DownloadFunction() {
        const token = await Token.getTokenWithExpiry("token");
        const files: Array<any> = [];
        this.files.forEach(e => files.push({id : this.getId(e), name: e.name}));
        //EventBus.$emit("BeginLoader", null);
        const axiosList: any = [];

        files.forEach((e) =>
            axiosList.push(
                axios.get(`${process.env.VUE_APP_BASE_URL}/files/download/-1/${e.name}`, {
                    withCredentials: true,
                    responseType: 'blob',
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-type": "application/json",
                    }
                })
            )
        );

        axios.all(axiosList)
        .then(axios.spread((...responses) => {
            for(let i = 0; i < responses.length; i++) {
                const response=responses[i] as AxiosResponse;
                console.log("resp: ",response);

                const data = response.data as Blob;
                const FILE = window.URL.createObjectURL(new Blob([data]));
                const link = document.createElement('a');
                link.href = FILE;
                let disposition = response.config.url;
                disposition === undefined ? disposition = "/file" : "";
                const temp=disposition.split('/');
                link.download = temp[temp.length - 1];
                document.body.appendChild(link);
                link.click();
                URL.revokeObjectURL(link.href);
                console.log("resp: ",data);
            }
            EventBus.$emit("unselected")
            EventBus.$emit("ReloadLogs", null);
        }))
        .catch(errors => {
            console.log(errors);
        })
    }

    //get /files/eml/:id/:name
    // Outlook draft (.eml, X-Unsent) with the selected .ramz attached and the
    // mission's address filled in; opening it starts a new Outlook message.
    private async OutlookFunction() {
        const token = await Token.getTokenWithExpiry("token");
        const file = this.files[0];
        const emlName = file.name.replace(/\.ramz$/, "") + ".eml";

        axios.get(`${process.env.VUE_APP_BASE_URL}/files/eml/${this.getId(file)}/${encodeURIComponent(file.name)}`, {
            withCredentials: true,
            responseType: 'blob',
            // the backend finds the mission from the file name; the selected
            // embassy is only a fallback
            params: this.target.id != null ? { target: this.target.id } : {},
            headers: {
                Authorization: `Bearer ${token}`,
            }
        })
        .then((response) => {
            downloadBlob(response.data as Blob, emlName);

            EventBus.$emit("showSnackbar", {
                text: `Outlook draft ${emlName} downloaded. Open it to send the file.`,
                color: "#4caf50",
            });
        })
        .catch((err) => {
            console.log("error:", err);
            EventBus.$emit("showSnackbar", {
                text: "Error: Outlook draft not created.",
                color: "#2196f3",
            });
        });
    }
}
